module.exports = __webpack_public_path__ + "static/media/img-fondo-casos-clinicos-mobile.5335dfca.png";